// token.js
const authToken = "83|1L4BSGPgTyoqs5zqas7sTc13o1E3g1yGNW3syEHD193bdea2";

export default authToken;
